import {Component, OnInit} from '@angular/core';
import {TitleService} from '../../services/title.service';
import {TokenService} from '../../services/token.service';
import {Router} from '@angular/router';

@Component({
  selector: 'IntroPage',
  templateUrl: 'introPage.component.html',
  styleUrls: ['introPage.component.scss']
})
export class IntroPageComponent implements OnInit{
  constructor(
    private tokenService: TokenService,
    private router: Router,
    private titleService: TitleService) {
    this.titleService.setTitle('Welcome');
  }


  ngOnInit(): void {
    if(this.tokenService.isAuthenticated()) {
      this.router.navigate(['/','home']);
    }
  }

}
